import { render, staticRenderFns } from "./fenqiPay.vue?vue&type=template&id=88fd1ae0&scoped=true&"
import script from "./fenqiPay.vue?vue&type=script&lang=js&"
export * from "./fenqiPay.vue?vue&type=script&lang=js&"
import style0 from "./fenqiPay.vue?vue&type=style&index=0&id=88fd1ae0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd1ae0",
  null
  
)

export default component.exports